module.exports = __webpack_public_path__ + "assets/normal/images/locked.d3de075c.png";